import instance from "@/axios";
import {productTypes} from "@/utils/common-constants";
import i18n from "@/i18n";
import {ElMessage} from "element-plus";
import { addCustmEvent } from "@/loadCountly";

export async function login(userInfo, invitation_code) {
    let formData = new FormData();
    formData.append('email', userInfo.email);
    formData.append('zbase_user_id', userInfo.user_id)
    formData.append('account_name', userInfo.username);
    formData.append('phone_number', userInfo.phone_number);
    formData.append('invitation_code', invitation_code)
    try {
        const resp = await instance.post('/api/user/login', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (resp.status !== 200) {
            return null;
        }
        let token = resp.headers['x-auth-token'];
        let expirationTime = resp.headers['expiration-time']
        if (token === null || typeof token === undefined) {
            return null;
        }
        let userData = resp.data.data;
        if (userData === null || typeof userData === undefined) {
            return null;
        }
        const userStr = JSON.stringify(userData);       
        localStorage.setItem('userInfo', userStr);
        let json_token = JSON.stringify({token: token, expirationTime: expirationTime})
        addCustmEvent('user_login', 'click', window.location.pathname, {'userInfo': userData});
        return json_token;
    } catch (err) {
        console.log(err)
        return null;
    }
}

export async function getUserInfo() {
    let userInfo = null;
    let env = checkEnv();
    if (env === 'location') {
        userInfo = {
            "user_id": 8640720,
            "email": "tanhang.long99@gmail.com",
            "username": "",
            "created_at": "2024-07-29 19:57:37",
            "phone_number": "",
            "utm_active_code": ""
        }
        return userInfo;
    }
    try {
        const response = await instance.get('user/v2/userinfo');
        if (response.data) {
            let result = response.data
            console.log("result:", result);
            if (result.code === 100000) {
                userInfo = result.userinfo;
                return userInfo;
            } else {
                console.log("获取用户登录状态失败: ", response)
                return null;
            }
        } else {
            console.log("获取用户登录状态失败: ", response);
            return null;
        }
    } catch (err) {
        console.log("获取用户登录状态失败: ", err);
        return null;
    }
}

export function checkGoodsName(goodsName) {

    if (!goodsName) {
        return "";
    }

    const name = goodsName.toLowerCase();

    // Special case for chatgpt-familypro
    if (name.includes('chatgpt-familypro')) {
        return 'chatgpt-familypro';
    }

    // Find matching product type (case-insensitive)
    const matchedProduct = productTypes.find(type =>
        name.includes(type.toLowerCase())
    );

    return matchedProduct ? matchedProduct.toLowerCase() : null;
}

export function getCarSeatList(seatList, goodsName, shareType) {
    let goodsNameLower = this.checkGoodsName(goodsName);
    if (['netflix', 'max'].includes(goodsNameLower)) {
        if (shareType === '5 profile(private)') {
            if (!seatList.includes("5 profile(private)")) {
                seatList.push("5 profile(private)");
            }
        }
        if (shareType === '1 profile(shared)') {
            if (!seatList.includes("1 profile(shared)")) {
                seatList.push("1 profile(shared)");
            }
        }
    } else if (goodsNameLower === 'disney+') {
        if (shareType === '7 profiles(private)') {
            if (!seatList.includes("7 profiles(private)")) {
                seatList.push("7 profiles(private)");
            }
        }
        if (shareType === '1 profile(shared)') {
            if (!seatList.includes("1 profile(shared)")) {
                seatList.push("1 profile(shared)");
            }
        }
    } else if (goodsNameLower === 'spotify') {
        if (shareType === 'private') {
            if (!seatList.includes("private")) {
                seatList.push("private");
            }
        }
    } else if (goodsNameLower === 'chatGPT-familyPro') {
        if (priceObj.plan_name === 'Plus' && !seatList.includes("Plus")) {
            seatList.push("Plus");
        } else if (priceObj.plan_name === 'Premium' && !seatList.includes("Premium")) {
            seatList.push("Premium");
        } else {
            if (!seatList.includes("Ultimate")) {
                seatList.push("Ultimate");
            }
        }
    } else if (goodsNameLower === 'duolinguo') {
        if (shareType === 'family plan' && !seatList.includes("family plan")) {
            seatList.push("family plan");
        }
    } else if (goodsNameLower === 'crunchyroll') {
        // 判断拼车的类型，添加到选择类型列表中
        if (shareType === '1 profile(shared)' && !seatList.includes("1 profile(shared)")) {
            // 共享拼车
            seatList.push("1 profile(shared)");
        }
    } else {
        // 车位情况
        if (shareType === 'private' && !seatList.includes("private")) {
            seatList.push("private");
        }
        if (shareType === 'shared' && !seatList.includes("shared")) {
            seatList.push("shared");
        }
    }
}

export function getIntervalTypeList(interval_type_list, used_interval_count, used_interval_type) {
    const key = used_interval_count + " " + used_interval_type;
    if (!interval_type_list.includes(key)) {
        interval_type_list.push(key)
    }
}

export function getPurchaseUnit(item) {
    const match = item.match(/(\d+)\s*(\w+)/);
    if (match) {
        const number = match[1];  // 提取数字
        const word = match[2];    // 提取数字后的词
        console.log(`数字: ${number}, 词: ${word}`);
        return word;
    } else {
        console.log("没有找到匹配的内容");
        return null;
    }
}

export function getPurchaseNum(item) {
    const match = item.match(/^\d+/); // 使用正则表达式提取开头的数字
    const number = match ? parseInt(match[0], 10) : null;
    return number;
}

export function checkEnv() {
    let env = process.env.VUE_APP_ENV
    // console.log(env);
    let environment = "production";
    switch (env) {
        case "development":
            environment = "location";
            break;
        case "test":
            environment = "sandbox";
            break;
        default:
            environment = "production";
            break;
    }
    return environment;
}

export function getHost() {
    let env = checkEnv();
    let host = "https://familypro.io";
    switch (env) {
        case "location":
            host = "http://localhost:8080";
            break;
        case "sandbox":
            host = "https://dev.familypro.io";
            break
        default:
            host = "https://familypro.io";
    }
    return host;
}


export async function getLocalOrRemoteUserInfo() {
    // First check localStorage
    let userInfoStr = localStorage.getItem("userInfo");
    if (userInfoStr) {
        try {
            let userInfo = JSON.parse(userInfoStr);
            // Check if userInfo has essential fields
            if (userInfo && userInfo.email) {
                return userInfo;
            }
        } catch (e) {
            console.log("Error parsing stored user info:", e);
        }
    }

    // If no valid local data, fetch from server
    return await getUserInfo();
}


export function formatTimestampToUKDateByTimestamp(timestamp) {
    if (timestamp == null || isNaN(timestamp)) {
        return null;
    }

    const date = new Date(timestamp * 1000);
    if (isNaN(date.getTime())) {
        console.error("Invalid timestamp:", timestamp);
        return null;
    }

    // 缓存 formatter 实例
    const locale = 'en-GB';
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };
    const cacheKey = JSON.stringify({locale, options});

    if (!formatterCache.has(cacheKey)) {
        formatterCache.set(cacheKey, new Intl.DateTimeFormat(locale, options));
    }

    const formatter = formatterCache.get(cacheKey);
    return formatter.format(date);
}

export function dateFormatByStr(dateStr) {
    if (dateStr == null || dateStr === '' || dateStr === '--') {
        return null;
    }

    const date = new Date(dateStr + 'Z');
    if (isNaN(date.getTime())) {
        console.error("Invalid date string:", dateStr);
        return null;
    }
    const formatterCache = new Map();
    // 缓存 formatter 实例
    const locale = 'en-GB';
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    };
    const cacheKey = JSON.stringify({locale, options});

    if (!formatterCache.has(cacheKey)) {
        formatterCache.set(cacheKey, new Intl.DateTimeFormat(locale, options));
    }

    const formatter = formatterCache.get(cacheKey);
    return formatter.format(date);
}

export function formatDate(dateStr) {
    if (dateStr == null || dateStr === '' || dateStr === '--') {
        return null;
    }
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
        console.error("无效的日期字符串:", dateStr);
        return null;
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export async function copyText(text) {
    // 复制账号
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
            setTimeout(() => {
                console.log("复制成功");
                ElMessage.success(i18n.global.t('console.copy_the_results_success'));
            }, 500); // 显示复制成功信息2秒
        }).catch(err => {
            console.error('复制失败:', err);
            ElMessage.error(i18n.global.t('console.copy_the_results_failed'))
        });
    } else {
        console.log("复制")
        this.fallbackCopyText(text);
    }
}


export async function getUserEmail() {
    // 从localStorage中获取用户邮箱
    if (localStorage.getItem('userInfo')) {
      return JSON.parse(localStorage.getItem('userInfo')).email || null; // 假设邮箱在userInfo对象中
    } else {
      return null; // 如果没有userInfo，返回null
    }
}

export async function getUserId() {
    // 从localStorage中获取用户邮箱
    if (localStorage.getItem('userInfo')) {
      return JSON.parse(localStorage.getItem('userInfo')).user_id || null; // 假设邮箱在userInfo对象中
    } else {
      return null; // 如果没有userInfo，返回null
    }
}
